import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useBranding } from '../context/BrandingContext';

/**
 * Viral PLG badge for free-tier white-label orgs.
 */
const PoweredByBadge = ({ sx = {} }) => {
    const { branding } = useBranding();
    if (!branding?.showPoweredBy) return null;

    return (
        <Box sx={{ textAlign: 'center', py: 0.75, ...sx }}>
            <Typography variant="caption" color="text.secondary">
                Powered by{' '}
                <Link
                    href="https://emaillion.net/?utm_source=whitelabel&utm_medium=poweredby"
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    sx={{ fontWeight: 700 }}
                >
                    Email Lion
                </Link>
            </Typography>
        </Box>
    );
};

export default PoweredByBadge;
